module.exports = __webpack_public_path__ + "static/media/prick_HMPG_header_image_01_600M.4902a16a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_header_image_01_600M.jpg
// module id = 342
// module chunks = 0